module.exports = __webpack_public_path__ + "img/icon-nav-report-white.f05defb.svg";